/**
 * HFL Landing — shared scene switcher
 * Loaded once via hfl-hero section. Reads scene data from window.HFL_SCENES.
 */
(function() {
  if (window.__hflInit) return;
  window.__hflInit = true;

  var scenes = window.HFL_SCENES;
  if (!scenes) return;

  var params = new URLSearchParams(window.location.search);
  var requested = params.get('scene');
  var active = scenes[requested] ? requested : 'camping';

  var titleEl = document.querySelector('[data-hfl-hero-title]');
  var copyEl = document.querySelector('[data-hfl-hero-copy]');
  var sceneSelect = document.getElementById('hfl-scene-select');
  var tabs = Array.from(document.querySelectorAll('.hfl-tab'));

  function setScene(key, updateUrl) {
    var scene = scenes[key] || scenes.camping;
    active = key;
    if (titleEl) titleEl.textContent = scene.title;
    if (copyEl) copyEl.textContent = scene.copy;
    if (sceneSelect) sceneSelect.value = key;

    tabs.forEach(function(tab) {
      var isActive = tab.dataset.scene === key;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    if (updateUrl !== false) {
      var url = new URL(window.location);
      url.searchParams.set('scene', key);
      history.replaceState(null, '', url);
    }
  }

  tabs.forEach(function(tab) {
    tab.addEventListener('click', function() { setScene(tab.dataset.scene); });
  });

  if (sceneSelect) {
    sceneSelect.addEventListener('change', function() { setScene(sceneSelect.value); });
  }

  setScene(active, false);
})();
